import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avmFileCounter',
    standalone: true,
})
export class AvmFileCounterPipe implements PipeTransform {
    /**
     * Formate le nombre de dossier supérieur à 1000.
     * @param number : nombre de dossiers
     */
    transform(number: any): string {
        if (!isNaN(parseFloat(String(number))) || isFinite(number)) {
            let result = Number(number);
            if (result >= 1000) {
                return `${Math.trunc(result / 1000)}K+`;
            } else {
                return String(number);
            }
        } else {
            return number;
        }
    }
}
